import React, { useEffect, useState } from "react";

import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Typography,
  Button,
  CircularProgress,
  Alert,
  Grid,
} from "@mui/material";
import request from "../../../utilities/requests";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import PaymentForm from "./PaymentForm";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const PreviewPayment = ({ invoiceId, method, onSuccess }) => {
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [clientSecret, setClientSecret] = useState(null);

  useEffect(() => {
    const fetchPreview = async () => {
      setLoading(true);
      const ids = Array.isArray(invoiceId) ? invoiceId : [invoiceId];

      try {
        const res = await request(
          `contracts/invoice/preview?invoiceIds=${ids.join(",")}&method=${method}`
        );
        if (res.success) {
          setPreview(res.data);
          if (res.clientSecret) {
            setClientSecret(res.clientSecret);
          }
        } else {
          setError(res.error);
        }
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };
    fetchPreview();
  }, [invoiceId, method]);


  const handleConfirm = async () => {
    const body = { method, invoiceIds: invoiceId };
    setLoading(true);
    const result = await request(
      `contracts/invoice/createpayment`,
      "post",
      body
    );
    if (result.success) {
      setClientSecret(result.clientSecret);
    }
    setLoading(false);
  };

  if (loading) {
    return (
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{ minHeight: 200 }}
      >
        <CircularProgress />
      </Grid>
    );
  }
  if (error) return <Alert severity="error">{error}</Alert>;
  if (!preview) return null;

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      spacing={2}
    >
      <Grid
        item
        xs={12}
        sm={10}
        md={10}
        lg={6}
        sx={{
          width: {
            xs: "100%",
            sm: "83.3333%",
            md: "66.6667%",
            lg: "50%",
          },
        }}
      >
        <Typography variant="h6" gutterBottom>
          Payment Breakdown
        </Typography>
        <TableContainer component={Paper} sx={{ mb: 2 }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Description</TableCell>
                <TableCell align="right">Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Base Amount</TableCell>
                <TableCell align="right">{preview.base.toFixed(2)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  {preview?.feeText}
                </TableCell>
                <TableCell align="right">{preview.fee.toFixed(2)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <strong>Total</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>{preview.total.toFixed(2)}</strong>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        {clientSecret ? null : (
          <Button variant="contained" onClick={handleConfirm}>
            Confirm and Pay
          </Button>
        )}
      </Grid>
      {clientSecret ? (
        <Grid
          item
          xs={12}
          sm={10}
          md={8}
          lg={6}
          sx={{
            width: {
              xs: "100%",
              sm: "83.3333%",
              md: "66.6667%",
              lg: "50%",
            },
          }}
        >
          <Elements stripe={stripePromise} options={{ clientSecret }}>
            <PaymentForm invoiceId={invoiceId}/>
          </Elements>

        </Grid>
      ) : null}
    </Grid>
  );
};

export default PreviewPayment;
